import { Spin, Timeline, Typography } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { StatusBadge } from '@/Ship/Components/UI/StatusBadge/StatusBadge'
import { formatAppDate } from '@/Ship/Helpers/appTime'

import { SHIFT_STATUS_OPTIONS } from '../Contracts/ShiftStatus'
import {
    changedByLabel,
    completeSnapshotLines,
    ShiftStatusHistoryStore,
    startSnapshotLines,
} from '../Stores/ShiftStatusHistoryStore'

const { Text } = Typography

interface Props {
    shiftUuid: string
    /** Поточний статус зміни: після дії він змінюється — перезавантажуємо історію */
    status?: string
}

/** Історія статусів зміни — таймлайн як у картці задачі; час у поясі застосунку (Київ) */
export const ShiftStatusHistory = observer(({ shiftUuid, status }: Props) => {
    const [store] = useState(() => new ShiftStatusHistoryStore())

    useEffect(() => {
        store.load(shiftUuid)
    }, [store, shiftUuid, status])

    if (store.loading && !store.items.length) return <Spin style={{ display: 'block', margin: '20px auto' }} />
    if (store.error) return <Text type="danger">{store.error}</Text>
    if (!store.items.length) return <Text type="secondary">Історія порожня</Text>

    return (
        <Timeline
            items={store.items.map((item) => {
                const option = SHIFT_STATUS_OPTIONS.find((o) => o.value === item.status)
                return {
                    key: item.uuid,
                    color: option?.color ?? '#8c8c8c',
                    content: (
                        <div data-testid="shift-status-history-item">
                            <StatusBadge option={option} fallbackLabel={item.status} />
                            <Text type="secondary" style={{ fontSize: 12, marginLeft: 6 }}>
                                {formatAppDate(item.occurredAt, 'DD.MM.YYYY, HH:mm') ?? ''}
                            </Text>
                            <div style={{ marginTop: 2 }}>
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    Змінив(ла): {changedByLabel(item)}
                                </Text>
                            </div>
                            {/* Первинні дані відкриття: не змінюються, навіть якщо диспетчер виправив зміну */}
                            {startSnapshotLines(item).map((line) => (
                                <div key={line} style={{ marginTop: 2 }} data-testid="shift-start-snapshot">
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        {line}
                                    </Text>
                                </div>
                            ))}
                            {/* Дані закриття на момент «Завершити»: диспетчер міг потім виправити зміну */}
                            {completeSnapshotLines(item).map((line) => (
                                <div key={line} style={{ marginTop: 2 }} data-testid="shift-complete-snapshot">
                                    <Text type="secondary" style={{ fontSize: 12, whiteSpace: 'pre-line' }}>
                                        {line}
                                    </Text>
                                </div>
                            ))}
                        </div>
                    ),
                }
            })}
        />
    )
})
